/**
 * Marca do Pix simplificada (monocromática, segue currentColor) — o
 * react-icons desta versão ainda não traz o ícone oficial.
 */
export const PixIcon = ({ className }: { className?: string }) => (
	<svg
		className={className}
		viewBox="0 0 24 24"
		width="1em"
		height="1em"
		fill="currentColor"
		aria-hidden
	>
		<path d="M17.51 6.65l3.84 3.84c.83.83.83 2.19 0 3.02l-3.84 3.84h-.86a2.7 2.7 0 01-1.92-.8l-2.37-2.36a.52.52 0 00-.72 0l-2.38 2.38a2.7 2.7 0 01-1.92.79h-.85L2.65 13.5a2.13 2.13 0 010-3.02L6.5 6.65h.84a2.7 2.7 0 011.92.8l2.38 2.37c.2.2.52.2.72 0l2.37-2.37a2.7 2.7 0 011.92-.8h.85zm-9.4 1.2h-.35L4.4 11.2a.93.93 0 000 1.32l3.35 3.35h.35c.4 0 .78-.16 1.07-.44l2.38-2.38a1.72 1.72 0 012.42 0l2.37 2.37c.29.29.67.45 1.07.45h.36l3.35-3.36a.93.93 0 000-1.31l-3.35-3.36h-.36c-.4 0-.78.16-1.07.45l-2.37 2.37c-.67.67-1.75.67-2.42 0L9.17 8.29a1.5 1.5 0 00-1.07-.44zM12 1.75l3.08 3.08h-1.7L12 3.45l-1.38 1.38h-1.7L12 1.75zm0 20.5l-3.08-3.08h1.7L12 20.55l1.38-1.38h1.7L12 22.25z" />
	</svg>
);
